import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraTabBar } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DocumentsTab } from './DocumentsTab';
import { LineageTab } from './LineageTab';
import { ModificationsTab } from './ModificationsTab';
const SUB_TABS = [
    'documents',
    'modifications',
    'lineage'
];
const PANELS = {
    documents: DocumentsTab,
    modifications: ModificationsTab,
    lineage: LineageTab
};
export function DocsTab({ programId }) {
    // ?tab= deep-links a sub-tab (the retired /v2?screen=modifications redirect
    // and the program-home work panel both land on modifications directly).
    const [searchParams] = useSearchParams();
    const requested = searchParams.get('tab');
    const [active, setActive] = useState(requested && SUB_TABS.includes(requested) ? requested : 'documents');
    // Only the active panel mounts — the same lifecycle Radix TabsContent had.
    const ActivePanel = PANELS[active];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraTabBar, {
                label: "Documents sections",
                value: active,
                onValueChange: setActive,
                options: [
                    {
                        value: 'documents',
                        label: 'Documents',
                        testId: Testids.deliveryDocs.subTabDocuments
                    },
                    {
                        value: 'modifications',
                        label: 'Modifications',
                        testId: Testids.deliveryDocs.subTabModifications
                    },
                    {
                        value: 'lineage',
                        label: 'Lineage',
                        testId: Testids.deliveryDocs.subTabLineage
                    }
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-6",
                children: /*#__PURE__*/ _jsx(ActivePanel, {
                    programId: programId
                })
            })
        ]
    });
}
